export default "__VITE_ASSET__b2e7a21a__"